module.exports = __webpack_public_path__ + "img/reply.99ae92a2.svg";